<template>
  <div>
    <a-form :form="form" v-bind="formLayout">
      <a-row :gutter="[16,16]">
        <a-col :span="12">
          <a-form-item label="单位">
            <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="组合" >
            <a-input v-decorator="['show', {rules: [{required: true, message: '必填项，请填写信息'}, {max:12, message: '输入超出长度限制'}]}]" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="金蝶编码">
            <a-input v-decorator="['jd_code', {rules: [{required: true, message: '必填项，请填写信息'}, {max:16, message: '输入超出长度限制'}]}]" />
          </a-form-item>
        </a-col>
        <a-col span="24" style="text-align: center">
          <a-button style="margin-right: 40px;" type="primary" html-type="submit" @click="handleSubmit" :loading="loading">提交</a-button>
          <a-button style="margin-left: 40px;" @click="handleGoBack">返回</a-button>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { common_currency_update } from '@/api/common'
// 表单字段
const fields = ['id', 'name', 'show', 'jd_code']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 9 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      form: this.$form.createForm(this),
      id: 0,
      loading: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      fields.forEach(v => this.form.getFieldDecorator(v))
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (err) {
          console.log(values, err)
          return
        }
        this.loading = true
        common_currency_update(values, this.id)
          .then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
            }
          }).finally(() => {
            this.loading = false
        })
      })
    },
    loadEditInfo (data) {
      const { form } = this
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        this.id = formData.id
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
